import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ResponsiveAppBar from '../widgets/ResponsiveAppBar';
import BeatsContent from './beats/beats_site';
import CompanySite from './teams/team_site';
import CompanyDetailSite from './teams/team_detail_site';
import WelcomeSite from './welcome_site';
import { useAuth } from '../providers/AuthProvider';
import LoginSite from './login_site';
import AccessDeniedSite from './access_denied_site';

function MainSite() {
  const { userState, setUserState } = useAuth();

  const ProtectedRoute = ({ children }) => {
    return userState?.accessToken ? children : <Navigate to="/login" />;
  };

  const ProtectedSystemAdminRoute = ({ children }) => {
    if(!userState?.accessToken) {
      return <Navigate to="/login" />
    }
    return userState.role == "systemadmin" ? children : <AccessDeniedSite/>;
  };

  const ProtectedAdminRoute = ({ children }) => {
    if(!userState?.accessToken) {
      return <Navigate to="/login" />
    }
    return userState.role == "admin" || userState.role == "systemadmin" ? children : <AccessDeniedSite/>;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ResponsiveAppBar />}>
          <Route index element={
            <ProtectedRoute>
              <WelcomeSite/>
            </ProtectedRoute>
          }/>
          <Route path="beats" element={
            <ProtectedSystemAdminRoute>
              <BeatsContent/>
            </ProtectedSystemAdminRoute>
          }/>
          <Route path="teams" element={
            <ProtectedAdminRoute>
              <CompanySite/>
            </ProtectedAdminRoute>
          }/>
          <Route path="teams/:id" element={
            <ProtectedAdminRoute>
              <CompanyDetailSite/>
            </ProtectedAdminRoute>
          }/>
        </Route>
        <Route path='/login' element={<LoginSite/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default MainSite;
